<template>
  <div>
    <!-- if this is active route (e.g. /users) -->
    <template v-if="isCurrentRoute">
      <h2>{{ $t('views.medicalpersons.affiliations.title') }}</h2>
      <entity-entry-table :entityKey="eCurrent.key" :entityBy="eParent" :tableSettings="table">
        <template #cell(type)="data">
          <b-badge variant="dark">{{ data.cell.value }}</b-badge>
        </template>
        <template #cell(startDate)="data">
          {{ data.cell.item.formattedCreatedDate }}
        </template>

        <template #cell(endDate)="data">
          {{ data.cell.item.formattedUpdatedDate }}
        </template>

        <template #cell(isActive)="data">
          {{ data.cell.item.isActive ? $t('views.medicalpersons.affiliations.active') : $t('views.medicalpersons.affiliations.inactive') }}
        </template>

        <template #cell(isPrimaryAffiliation)="data">
          {{ data.cell.item.isPrimaryAffiliation ? $t('views.medicalpersons.affiliations.yes') : $t('views.medicalpersons.affiliations.no') }}
        </template>
      </entity-entry-table>
    </template>

    <!-- if subroute is active route (e.g. /users/detail) -->
    <section v-else>
      <router-view />
    </section>
  </div>
</template>

<script>
import { CLASS_TABLE_FIELD_KEY_ALL } from '@/assets/js/config/client'

import { TableHelper } from '@/assets/js/helper/table'

import EntityEntryTable from '@/components/entity/EntryTable'
import MixinEntityBase from '@/components/mixins/EntityBase'

const ENTITY_KEY = 'medicalpersonaffiliations'

export default {
  name: 'MedicalPersons.Affiliations',
  mixins: [MixinEntityBase],
  components: {
    EntityEntryTable
  },
  data () {
    return {
      entityKey: ENTITY_KEY,
      table: {
        helper: TableHelper,
        mapper: this.tableEntitiesMapper,
        options: {
          fields: {
            includes: ['startDate', 'endDate'],
            excludes: [],
            sorting: ['type', 'role', 'institution', 'startDate', 'endDate', 'isActive', 'email', 'isPrimaryAffiliation'],
            sortable: [CLASS_TABLE_FIELD_KEY_ALL],
            labelKey: `views.${this.$options.name.toLowerCase()}.table.label.{field}`,
            label: {},
            variant: {},
            class: {
              type: 'cell-min',
              status: 'cell-min cell-align-right'
            },
            thClass: {
              type: 'cell-nowrap'
            },
            tdClass: {}
          }
        },
        events: {
          rowClicked: this.tableRowClicked
        }
      }
    }
  },
  computed: {
    isCurrentRoute () {
      return Object.values(this.$route.matched[this.$route.matched.length - 1].components).find(c => c.name === this.$options.name) !== undefined
    }
  },
  methods: {
    formatDate (dateString) {
      if (!dateString) {
        return ''
      }

      const date = new Date(dateString)
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()
      return `${day}.${month}.${year}`
    },
    tableEntitiesMapper (entities) {
      return entities
        .map(e => Object.assign({
          $routerLink: {
            name: `${this.$options.name}.Detail`,
            params: {
              [this.eCurrent.paramKey]: e.id
            }
          },
          formattedCreatedDate: this.formatDate(e.startDate),
          formattedUpdatedDate: this.formatDate(e.endDate)
        }, e))
    },
    tableRowClicked (entity) {
      this.$router.push(entity.$routerLink)
    }
  },
  created () {
    TableHelper.rowClassHook(entity => entity.$routerLink ? 'has-routerlink' : null)
  }
}
</script>

<style lang="scss"></style>
